import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Loader({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    let cur = 0;
    const interval = setInterval(() => {
      cur = Math.min(cur + Math.random() * 4 + 0.5, 100);
      setProgress(Math.floor(cur));
      if (cur >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          setFading(true);
          setTimeout(onDone, 500);
        }, 150);
      }
    }, 28);
    return () => clearInterval(interval);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!fading && (
        <motion.div
          key="loader"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: '#04080f',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: '24px',
          }}
        >
          {/* spinner ring */}
          <div style={{ position: 'relative', width: '48px', height: '48px' }}>
            {/* track */}
            <div style={{
              position: 'absolute', inset: 0,
              borderRadius: '50%',
              border: '1.5px solid rgba(255,255,255,0.07)',
            }} />
            {/* progress arc via conic-gradient */}
            <div style={{
              position: 'absolute', inset: 0,
              borderRadius: '50%',
              background: `conic-gradient(#f4f4f4 ${progress * 3.6}deg, transparent ${progress * 3.6}deg)`,
              WebkitMask: 'radial-gradient(circle, transparent 19px, black 20px)',
              mask: 'radial-gradient(circle, transparent 19px, black 20px)',
              transition: 'background 0.05s linear',
            }} />
          </div>

          {/* percent */}
          <div style={{
            fontFamily: "'Share Tech Mono', monospace",
            fontSize: '13px', fontWeight: 300,
            letterSpacing: '0.2em',
            color: 'rgba(244,244,244,0.35)',
          }}>
            {String(progress).padStart(3, '0')}%
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
